/* eslint-disable */
import PropTypes from 'prop-types';
import AuthEntityPropTypes from '../../Services/Auth/Auth.service.props';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const OrderConfirmationDialogPropTypes = {
  /**
   * The current `auth` or `null`
   */
  auth: AuthEntityPropTypes.auth,

  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * fullScreen
   */
  fullScreen: PropTypes.bool.isRequired,

  /**
   * The order code
   */
  orderCode: PropTypes.string,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,

  /**
   * The width of the screen. Provided by @material-ui/core/withWidth
   */
  width: PropTypes.string.isRequired,
};

export default OrderConfirmationDialogPropTypes;
